import { LoadingButton } from "@mui/lab";
import { Box, Button, Modal, Typography, useMediaQuery } from "@mui/material";
import { useState } from "react";
import FileUpload from "react-material-file-upload";
import { useAgregarInformadoMutation } from "../../redux/api/informeApi";
import { IInforme } from "../../redux/models/typesInformes";
import { useAppSelector } from "../../redux/store";
import MyToastShow from "../Layout/MyToast";
import EnvioProgramado from "./EnvioProgramado";
import dayjs from "dayjs";


type ModalInformadoProps = {
    open: boolean,
    onCancel: () => void,
    informe?: IInforme,
    onInformado: (informe: IInforme) => void
}
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    boxShadow: 24,
    p: 4,
};


const ModalInformado = ({ open, onCancel, informe, onInformado }: ModalInformadoProps) => {
    const darkMode = useAppSelector(state => state.theme.darkTheme)

    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
    const boxWidth = isMobile ? '100%' : '40rem'
    const [files, setFiles] = useState<File[]>([])
    const [agregarInformado, { isLoading: loadingAgregarInformado }] = useAgregarInformadoMutation()
    const [selectFecha, setSelectFecha] = useState<Date | any>(dayjs().toDate().toISOString());



    const handleUpload = () => {
        const id = informe?.id || -1
        informe && agregarInformado({ idInforme: id, archivo: files[0], fecha: selectFecha }).unwrap()
            .then(() => {
                MyToastShow({ message: 'Informe Informado', type: 'success' })
                onInformado({ ...informe, estadoGeneral: 2 })
                handleClose()
            })
            .catch(() => {
                MyToastShow({ message: 'Hubo un error al agregar el informado', type: 'error' })
            })
    }

    const handleClose = () => {
        setFiles([])
        onCancel()
    }


    return (
        <Modal
            open={open}
            onClose={onCancel}
            sx={{
                width: '100%',
            }}
        >
            <Box sx={(theme) => ({
                ...style,
                width: boxWidth,
                overflow: 'auto',
                maxHeight: '100%',
                bgcolor: darkMode ? '#232323' : '#fff',

            })}
            >
                <Typography variant='h4'>Informado</Typography>
                <Typography variant='h6' fontWeight='200'>Informe ID: {informe?.id}</Typography>

                <FileUpload
                    accept={['.jpg', '.jpeg', '.png', '.pdf']}
                    sx={{ my: '1rem' }}
                    value={files}
                    onChange={(f) => setFiles(f)}
                    buttonText="Agregar"
                    title={'Agregar un informado'}
                />
                <EnvioProgramado onChange={(fecha) => {
                    if (dayjs(fecha).isSame(dayjs(), 'minute')) {
                        fecha = dayjs(fecha).add(2, 'minute').toDate().toISOString();
                    }
                    setSelectFecha(fecha)
                }} value={selectFecha} />


                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button variant='outlined' color='primary' sx={{ ml: 1 }} onClick={onCancel}> Cerrar </Button>
                    <LoadingButton variant='contained' color='primary' sx={{ ml: 1 }} onClick={handleUpload}
                        disabled={files.length === 0}
                        loading={loadingAgregarInformado}
                    > Enviar </LoadingButton>
                </Box>
            </Box>
        </Modal>

    );
}



export default ModalInformado; 